'use client';

import { cn } from '@coas/ui/lib';
import { NavLink } from '~/entities/NavLink';
import type { PropsOf } from '~/shared/lib';
import { useSession } from '~/shared/lib/auth';
import { Spinner } from '~/shared/ui/spinner';

type HeaderNavLinkProps = PropsOf<typeof NavLink> & {
    authenticated?: boolean;
};

export const HeaderNavLink = ({ authenticated = false, className, activeClassName, ...props }: HeaderNavLinkProps) => {
    const { isPending: isSessionPending } = useSession();

    if (authenticated && isSessionPending) {
        return (
            <NavLink
                {...props}
                href={''}
                className={cn('pointer-events-none child:fill-neutral-200', className)}
                activeClassName={activeClassName}
                tabIndex={-1}
                aria-disabled
            >
                <Spinner className={'size-5 md:size-6'} />
            </NavLink>
        );
    }

    return (
        <NavLink
            {...props}
            className={cn('fade-in animate-in child:stroke-neutral-200 duration-500', className)}
            activeClassName={activeClassName}
        />
    );
};
